export const ADD_USER_MUTATION = gql`
    mutation createUser($input: CreateUserInput!) {
        createUser(input: $input) {
            email
            firstName
            lastName
            roleId
        }
    }
`;
